<template lang="pug">
	.connection-status
		.tags.are-medium.has-addons
			.tag.is-dark.connection-status-label(v-if="$mq !== 'mobile'") Status
			.tag(:class="classes")
				.icon
					i.fas.fa-circle-notch.fa-spin(v-if="connectionStatus === null || connectionStatus === 'reconnecting'")
					i.fas.fa-futbol.fa-spin(v-if="connectionStatus === 'connected'")
				span {{ connectionStatusText }}
</template>

<script>
export default {
	props: {
		connectionStatus: String,
		status: String
	},
	computed: {
		classes () {
			switch (this.connectionStatus) {
			case null: return 'is-light'
			case 'reconnecting': return 'is-warning'
			case 'connected': return 'is-light'
			}
			return null
		},
		icon () { return null },
		connectionStatusText () {
			switch (this.connectionStatus) {
			case null: return 'Verbinde mit Liveticker...'
			case 'reconnecting': return 'Stelle Verbindung wieder her...'
			case 'connected':
				if (this.status === 'none' || this.status === 'upcoming') {
					return 'Mit Echtzeit-Nachrichten verbunden..'
				} else {
					return 'Mit Echtzeit-Nachrichten verbunden..'
				}
			}
			return null
		}
	}
}
</script>

<style lang="scss" scoped>
	.connection-status {
		margin-bottom: 1em;
		@media screen and (max-width: 768px) {
			margin-bottom: 0;
			.tags.are-medium .tag {
				font-size: 0.8em !important;
				white-space: normal;
				margin-bottom: 0;
				height: auto;
			}
			padding: 0.2em;
		}
	}

</style>
